// const LOCAL_URL = "http://localhost:3001"   
const LOCAL_URL = "https://api-dev.auttom.io"
// const LOCAL_URL = "https://api.auttom.io"   
export const BASE_URL = import.meta.env.VITE_API_BASE_URL || LOCAL_URL;